<template lang="pug">
  .trace-hierarchy
    .panel.panel-default
      .panel-heading.panel-title Hierarchy Information
      .panel-body
        .text-center
          div(v-if="parent")
            div
              div {{parent.packageType.name}}
              router-link.kzcode-default.clickable(:to="{name: 'traceDetails', params: {code: parent.code}}") {{parent.code}}
            i.fa.fa-arrows-v.p10
          div(v-if="self")
            div
              div {{self.packageType.name}}
              a.kzcode-default.bold {{self.code}}
            div(v-if="self.descendantCount")
              i.fa.fa-arrows-v.p10
              div {{self.descendantCount}} children
              i.fa.fa-spinner.fa-pulse.fa-spin(v-if="loading")
              a.fa.fa-plus(@click="getChildren" v-if="!children && !loading")
              a.fa.fa-minus(@click="children = null" v-if="children && !loading")
                ul(v-for="c in children")
                  router-link.kzcode-default.clickable(:to="{name: 'traceDetails', params: {code: c.code}}") {{c.code}}

</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'

export default {
  props: {
    self: {
      type: Object,
      required: true
    },
    parent: {
      type: Object
    }
  },
  data: () => ({
    children: null,
    loading: false
  }),
  methods: {
    getChildren() {
      this.loading = true
      TrackNTrace.getChildrenCodes(this.self.code)
        .then((resp) => {
          this.children = resp.data.children
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/HierarchyDetails.vue